// extracted by mini-css-extract-plugin
export default {"AdSlotMail__mail":"bgg_a bhe_wj bhe_a bhe_q bhe_k","AdSlotMail__mail--notLoaded":"bgg_b bhe_ey bhe_bj bhe_wy","show-ad-not-loaded":"bgg_c","AdSlotMail__cta":"bgg_e"};